import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { esasKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-form-esas-table',
    templateUrl: './form-esas-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        TranslatePipe,
    ],
})
export class FormEsasTableComponent extends FormBaseTableComponent {

    constructor() {
        super();
        this.generateColumns(esasKeys);
    }
}
